import {
  FlatList,
  Image,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  RefreshControl,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import React, { useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useAppNavigation } from '../../../../types/@react-navigation/navigation';
import {
  addReadyMadeProduct,
  getAllProductCatalog,
} from '../../../../redux/slices/readymadeProductSlice';
import { config } from '../../../../shared/environment';
import CommonService from '../../../../shared/services/commonService';
import {
  ZenCheckBox,
  ZenEmptyComponent,
  ZenIcon,
  ZenLoader,
  ZenSearchBar,
  ZenToast,
} from 'zen-core-elements';
/*
 * Imported from the package root, not from the file inside it: webpack aliases
 * the bare specifier to the web barrel, and a deep import bypasses that alias -
 * this dropdown would have been the one screen still missing the web stacking
 * fix. The barrel re-exports the same component, so Android resolves exactly
 * what it resolved before.
 */
import { ZenDropdown } from 'zen-core-elements';
import { appColors } from '../../../../themes/appTheme';
import CommonHeader from '../../../../shared/commonComponents/commonHeader';
import { ThemeConsumer } from '@rneui/themed';
import ZenText from 'zen-core-elements/src/elements/zenText/zenText';
import { addReadyMadeProductPayload, ProductCatalogItem } from './readymadeProducts.model';
import { CustomModal } from '../../../../shared/commonComponents/customModal';
import useBackHandler from '../../../../shared/hooks/useBackHandler';
import { getAllPosCategoryData } from '../../../../redux/slices/categorySlice';

const limit = 10;

const ReadymadeProducts = () => {
  useBackHandler()
  //used to dispatch actions
  const dispatch = useAppDispatch();
  const readymadeProductsData = useAppSelector((state) => state.readumadeProdut.posReadymadeProduct);
  const categoryData = useAppSelector((state) => state.category?.categoryDataValue?.value);
  //Variable used to handle paga loader
  const [isLoading, setIsLoading] = useState<boolean>(!readymadeProductsData?.value);
  //variable to store offset value
  const [offset, setOffset] = useState<number>(0);
  //State variable to store boolean value for footer section loading
  const [isFooterLoading, setIsFooterLoading] = useState<boolean>(true)
  //Variable used to store device width
  const { width } = useWindowDimensions();
  const [transparentLoader, setTransparentLoader] = useState(false)
  //Variable used to store ready-made products list data
  const [readymadeProducts, setReadymadeProducts] = useState<ProductCatalogItem[]>(readymadeProductsData?.value || []);
  //variable to store search value
  const [searchData, setSearchData] = useState<string>('');
  //variable for handle refresh control
  const [listRefresh, setListRefresh] = useState(false);
  //Variable used to store navigation from useNavigation hook
  const navigation = useAppNavigation();
  const [categoryValue, setCategoryValue] = useState<number>(-1);
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<addReadyMadeProductPayload[]>([]);
  const industryId = useAppSelector(state => state?.common?.currentUser.value?.industry?.id)
  const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'
  const onMomentumScrollBegin = useRef(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (categoryData?.length > 0) {
      return;
    }
    getAllCategoriesName();
  }, [])

  useEffect(() => {
    if (readymadeProductsData?.value)
      setReadymadeProducts(readymadeProductsData?.value)
  }, [readymadeProductsData?.value])

  //useEffect triggered  when search data changes
  useEffect(() => {
    if (isFirstRender.current) return;
    if (searchData) {
      setIsLoading(true);
      const debounceSearchText = setTimeout(() => {
        setOffset(0);
        getAllProductCatalogApi(0, undefined, searchData);
      }, 1000);
      return () => {
        clearTimeout(debounceSearchText);
      };
    } else {
      setOffset(0);
      getAllProductCatalogApi(0, undefined, '');
    }
  }, [searchData]);

  useEffect(() => {
    if (isFirstRender.current && (readymadeProductsData?.value?.length || 0) > 0) return;
    console.log(categoryValue, "categoryValue=====================categoryValue");
    setIsLoading(true);
    setOffset(0);
    getAllProductCatalogApi(0, categoryValue);
  }, [categoryValue]);

  useEffect(() => {
    isFirstRender.current = false;
  }, [])

  //method for selecting and deselecting items
  const selectDeseletedItem = (event: ProductCatalogItem) => {
    setSelectedProduct((prev) => {
      let data = prev?.filter((item) => item?.id != event?.id)
      if (data?.length == prev?.length) {
        data?.push({
          featuredImage: event?.featuredImage,
          id: event?.id,
          locationId: 5, // Hardcoded in original ?
          name: event?.name,
          price: event?.price,
          storeId: config.storeId,
        })
      }
      return data
    })
  }

  //function used to ready-made products list
  const getAllProductCatalogApi = async (customOffset?: number, customCategory?: number, customSearch?: string) => {
    const currentOffset = customOffset !== undefined ? customOffset : ((!offset || offset === -1) ? 0 : offset);
    const currentCategory = customCategory !== undefined ? customCategory : categoryValue;
    const currentSearch = customSearch !== undefined ? customSearch : searchData;

    const payload = {
      data: {
        offset: currentOffset,
        limit,
        industryId: industryId!,
        storeId: config.storeId,
        categoryId: currentCategory == -1 ? "" : String(currentCategory),
        searchText: currentSearch,
      }, storeId: config.storeId
    }
    await dispatch(getAllProductCatalog(payload)).unwrap()
      .catch(err => {
        ZenToast({
          type: "error",
          message: "Failed to getting readymade products, Please try again after some time!!"
        })
      }).finally(() => {
        setIsLoading(false);
        setTransparentLoader(false)
        setListRefresh(false);
        setIsFooterLoading(false);
      })
  };

  const handleLongPress = (event: ProductCatalogItem) => {
    let data = [...readymadeProducts];
    data?.map(item => {
      if (item?.id === event?.id) {
        item.isSelected = item.isSelected ? false : true;
      }
    });
    setReadymadeProducts([...data]);
  };

  const getAllCategoriesName = async () => {
    await dispatch(getAllPosCategoryData({ storeId: config.storeId }))
      .unwrap()
      .then(async categoryResponse => {
        if (categoryResponse) {
          // getAllProductCatalogApi(0);
        }
      })
      .catch(err => {
        ZenToast({
          type: 'error',
          message:
            'Failed to getting categories name, Please try again after some time!!',
        });
      });
  };

  const addReadyMadeProductApi = async (event?: addReadyMadeProductPayload[]) => {
    setTransparentLoader(true);
    let payload = selectedProduct?.length > 0 ? selectedProduct : event!;
    if (!payload) {
      setTransparentLoader(false);
      return;
    }
    await dispatch(addReadyMadeProduct(payload))
      .unwrap()
      .then(async (addReadymadeResponse) => {
        if (addReadymadeResponse) {
          if (addReadymadeResponse.success) {
            if (addReadymadeResponse?.planExceed) {
              ZenToast({
                type: "error",
                message: addReadymadeResponse?.planExceed
              })
            } else {
              ZenToast({ message: addReadymadeResponse?.msg, type: "success" })
              getAllProductCatalogApi(0);
            }
            setSelectedProduct([])
            // Deselect all
            setReadymadeProducts(prev => prev.map(p => ({ ...p, isSelected: false })));
          }
        }
      })
      .catch(err => {
        ZenToast({ type: 'error', message: 'Failed to add product', });
      }).finally(() => {
        setTransparentLoader(false);
      });
  };

  const RenderItem = ({ item, index }: { item: ProductCatalogItem, index: number }) => {
    return (
      <ThemeConsumer>
        {({ theme }) => (
          <TouchableOpacity
            onPress={() => {
              if (selectedProduct.length > 0) {
                selectDeseletedItem(item);
                handleLongPress(item);
              } else {
                // On single press in original code:
                // if (width < 900 && selectedProduct?.length) { selectDeseletedItem... }
                // else? Original didn't seem to do anything on single press if no selection mode, 
                // wait, "onPress" event listener in original: "if (width < 900 && selectedProduct?.length)"
                // So single press only works in selection mode.
              }
            }}
            onLongPress={() => {
              // Original logic: if (width < 900 && !selectedProduct?.length) -> start selection
              if (!selectedProduct.length) {
                setSelectedProduct([{
                  featuredImage: item?.featuredImage,
                  id: item?.id,
                  locationId: 5,
                  name: item?.name,
                  price: item?.price,
                  storeId: config.storeId,
                }])
                handleLongPress(item);
              }
            }}
            activeOpacity={1}
            style={[theme.readymadeProductsStyle.renderItemContainer, { borderWidth: item?.isSelected ? 1 : 0 }]}
          >
            <View style={theme.readymadeProductsStyle.itemInnerRow}>
              <View style={theme.readymadeProductsStyle.itemLeftCol}>
                {/* Checkbox always visible if selection active? Or depends on original design? 
                                  Original had ZenCheckBox separately or via ZenList. 
                                  Let's mimic productList: Show checkbox if selection active or tablet.
                              */}
                {selectedProduct.length > 0 ? (
                  <View style={{ paddingTop: 0 }}>
                    <ZenCheckBox
                      onPress={() => { selectDeseletedItem(item); handleLongPress(item) }}
                      checked={item?.isSelected || false}
                      checkedColor={theme?.primary}
                      unCheckedColor={theme?.lightGrey}
                      containerStyle={theme.readymadeProductsStyle.checkBoxContainer}
                    />
                  </View>
                ) : null}

                <View style={theme.readymadeProductsStyle.itemImageRow}>
                  <Image
                    resizeMode="contain"
                    style={theme.readymadeProductsStyle.itemImage}
                    source={item?.featuredImage ? { uri: config?.AWSImageUrl + item?.featuredImage } : require("../../../../assets/noimage.jpg")}
                    defaultSource={require("../../../../assets/noimage.jpg")}
                  />
                  <View style={theme.readymadeProductsStyle.itemDetailContainer}>
                    <View style={[theme.readymadeProductsStyle.itemTextContainer, { maxWidth: "80%" }]}>
                      <ZenText content={item?.name} size={theme.mediumFontSize} color={theme.lightDark} bold={true} numberOfLines={1} />
                      <ZenText
                        content={item?.price ? CommonService.currencyStandard(currencySymbol, String(item?.price ?? 0)) : ''}
                        color={theme.lightDark}
                        size={theme?.smallFontSize}
                        bold={true}
                      />
                    </View>
                  </View>
                </View>

                <View style={theme.readymadeProductsStyle.itemActionContainer}>
                  {/* Add Button */}
                  <TouchableOpacity
                    onPress={() => {
                      // Add single product
                      addReadyMadeProductApi([{
                        featuredImage: item?.featuredImage,
                        id: item?.id,
                        locationId: 5,
                        name: item?.name,
                        price: item?.price,
                        storeId: config.storeId,
                      }])
                    }}
                    style={theme.readymadeProductsStyle.optionInnerContainer}
                  >
                    <ZenIcon name="plus" type="material-community" size={theme?.iconSize} color={theme?.green} />
                    {/* Optional text "Add" if space permits or just icon */}
                    <ZenText content="Add" style={theme.readymadeProductsStyle.optionTextStyle} color={theme.green} />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        )}
      </ThemeConsumer>
    );
  }

  return (
    <ThemeConsumer>
      {({ theme }) => (
        <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={theme.readymadeProductsStyle.containerView}>
          <CommonHeader backIcon backIconOnpress={() => navigation.goBack()} headerName="Ready-made Product" />
          <View style={theme.readymadeProductsStyle.searchContainer}>
            <View style={theme.readymadeProductsStyle.searchBarWrapper}>
              <ZenSearchBar
                search={searchData}
                setSearch={setSearchData}
                placeholderTextColor={appColors.lightDark}
                placeholder="Search by Product Name"
                searchContainerStyle={theme.readymadeProductsStyle.searchBarContainer}
                searchInputStyle={theme.readymadeProductsStyle.searchInput}
                onCancel={() => {
                  setSearchData('');
                  Keyboard?.dismiss();
                }}
              />
            </View>
            <View style={{ flex: width > 600 ? 0.2 : 0.3 }}>
              <ZenDropdown
                value={categoryValue}
                setValue={setCategoryValue}
                open={categoryOpen}
                setOpen={setCategoryOpen}
                items={[{ label: 'All', value: -1 }, ...categoryData?.map((item) => ({
                  label: item?.categoryName,
                  value: item?.id
                }))]}
                zIndex={1}
                searchable
                style={theme.readymadeProductsStyle.dropdownContainer}
                scrollViewProps={{
                  scrollEnabled: true,
                  nestedScrollEnabled: true,
                }}
              />
            </View>
          </View>

          {isLoading ? (
            <ZenLoader lottieType="Local" lottie={require('../../../../assets/infinityLoader.json')} />
          ) : (
            <FlatList
              data={readymadeProducts}
              renderItem={RenderItem}
              ListFooterComponent={isFooterLoading ? <View style={theme.productListStyle.listFooterLoader}>
                <ZenLoader size={"small"} color={theme?.primary} />
              </View> : <></>}
              keyExtractor={(item, index) => item.id?.toString() || index.toString()}
              contentContainerStyle={{
                paddingBottom: readymadeProducts?.length ? 10 : undefined,
                flex: readymadeProducts?.length ? undefined : 1,
                gap: readymadeProducts?.length ? 15 : undefined,
              }}
              onMomentumScrollBegin={() => { onMomentumScrollBegin.current = true }}
              onEndReached={() => {
                if (!onMomentumScrollBegin.current) return;
                if (isFooterLoading) return;
                if (Number(readymadeProductsData?.count) > offset + limit) {
                  setIsFooterLoading(true);
                  const newOffset = offset + limit;
                  setOffset(newOffset);
                  getAllProductCatalogApi(newOffset);
                }
              }}
              ListFooterComponentStyle={{ height: readymadeProductsData?.value?.length ? 20 : undefined }}
              refreshControl={
                <RefreshControl
                  refreshing={listRefresh}
                  onRefresh={() => {
                    setListRefresh(true)
                    setCategoryValue(-1)
                    setReadymadeProducts(prev => {
                      return prev?.map(product => {
                        return {
                          ...product,
                          isSelected: false
                        }
                      })
                    })
                    setSearchData("")
                    setOffset(0);
                    getAllProductCatalogApi(0, -1, "");
                  }}
                />
              }
              onEndReachedThreshold={0.01}
              ListEmptyComponent={<ZenEmptyComponent />}
              ListHeaderComponent={() => {
                if (selectedProduct?.length > 0) {
                  return (
                    <View style={theme.readymadeProductsStyle.selectAllHeader}>
                      <View style={theme.readymadeProductsStyle.selectAllLeft}>
                        <ZenCheckBox
                          title={selectedProduct?.length === readymadeProducts?.length ? 'Deselect All' : 'Select All'}
                          containerStyle={theme.readymadeProductsStyle.checkBoxContainer}
                          checkedColor={theme.primary}
                          onPress={() => {
                            if (selectedProduct.length === readymadeProducts.length) {
                              // Deselect all
                              setReadymadeProducts(prev => prev.map(p => ({ ...p, isSelected: false })));
                              setSelectedProduct([]);
                            } else {
                              // Select all
                              const allSelected = readymadeProducts.map(p => ({ ...p, isSelected: true }));
                              setReadymadeProducts(allSelected);
                              const allPayload = allSelected.map(p => ({
                                featuredImage: p?.featuredImage,
                                id: p?.id,
                                locationId: 5,
                                name: p?.name,
                                price: p?.price,
                                storeId: config.storeId,
                              }));
                              setSelectedProduct(allPayload);
                            }
                          }}
                          size={20}
                          checked={selectedProduct?.length === readymadeProducts?.length}
                        />
                      </View>
                      <View style={theme.readymadeProductsStyle.optionContainer}>
                        {width > 600 ? (
                          <TouchableOpacity
                            style={theme.readymadeProductsStyle.optionInnerContainer}
                            onPress={async () => {
                              await addReadyMadeProductApi();
                            }}
                          >
                            <ZenIcon
                              type="material-community"
                              name="plus"
                              size={22}
                              color={theme.green}
                            />
                            <ZenText
                              content={'Add Selected'}
                              style={[
                                theme.readymadeProductsStyle.optionTextStyle,
                                { color: theme.green },
                              ]}
                            />
                          </TouchableOpacity>
                        ) : null}
                      </View>
                    </View>
                  )
                }
                return null;
              }}
            />
          )}

          <CustomModal visible={transparentLoader} transparent>
            <ZenLoader lottie={require('../../../../assets/infinityLoader.json')} lottieType='Transparent' />
          </CustomModal>
        </KeyboardAvoidingView>
      )}
    </ThemeConsumer>
  );
};

export default ReadymadeProducts;
